import { render, staticRenderFns } from "./JangkaPendekExtendView.vue?vue&type=template&id=a4d22450&scoped=true&lang=pug&"
import script from "./JangkaPendekExtendView.vue?vue&type=script&lang=js&"
export * from "./JangkaPendekExtendView.vue?vue&type=script&lang=js&"
import style0 from "./JangkaPendekExtendView.vue?vue&type=style&index=0&id=a4d22450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d22450",
  null
  
)

export default component.exports